import { Dispatch } from 'redux';

import { PaymentMethod, getPaymentMethods } from 'api/userDashboard';
import { removeId } from 'utils/functional';

import { MainStoreErrorAction, setError } from './error';

// Types

type FetchPaymentMethodsRequestAction = {
  type: 'FETCH_PAYMENT_METHODS_REQUEST';
};

type FetchPaymentMethodsSuccessAction = {
  type: 'FETCH_PAYMENT_METHODS_SUCCESS';
  methods: Array<PaymentMethod>;
};

type AddPaymentMethodAction = {
  type: 'ADD_PAYMENT_METHOD';
  method: PaymentMethod;
};

type RemovePaymentMethodAction = {
  type: 'REMOVE_PAYMENT_METHOD';
  methodId: string;
};

export type MainStorePaymentMethodsAction =
  | FetchPaymentMethodsRequestAction
  | FetchPaymentMethodsSuccessAction
  | AddPaymentMethodAction
  | RemovePaymentMethodAction;

export type MainStorePaymentMethodsState = {
  methods: PaymentMethod[];
  isFetching: boolean;
};

// Reducer

export function paymentMethodsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStorePaymentMethodsState = {
    methods: [],
    isFetching: false,
  },
  action: MainStorePaymentMethodsAction,
) {
  switch (action.type) {
    case 'FETCH_PAYMENT_METHODS_REQUEST':
      return { ...state, isFetching: true };

    case 'FETCH_PAYMENT_METHODS_SUCCESS':
      return { ...state, isFetching: false, methods: action.methods };

    case 'ADD_PAYMENT_METHOD': {
      const { methods } = state;
      return { ...state, methods: [...methods, action.method] };
    }

    case 'REMOVE_PAYMENT_METHOD': {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line prefer-destructuring
      const methodId = action.methodId;
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line prefer-destructuring
      const methods = state.methods;

      if (!methods) {
        return state;
      }

      return { ...state, methods: removeId(methods, methodId) };
    }

    default:
      return state;
  }
}

// Actions

const fetchPaymentMethodsRequest = (): FetchPaymentMethodsRequestAction => ({
  type: 'FETCH_PAYMENT_METHODS_REQUEST',
});

const fetchPaymentMethodsSuccess = (
  methods: Array<PaymentMethod>,
): FetchPaymentMethodsSuccessAction => ({
  type: 'FETCH_PAYMENT_METHODS_SUCCESS',
  methods,
});

export const fetchPaymentMethods =
  () =>
  (
    dispatch: Dispatch<MainStorePaymentMethodsAction | MainStoreErrorAction>,
    getState: () => { paymentMethods: MainStorePaymentMethodsState },
  ) => {
    const state = getState();
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line prefer-destructuring
    const paymentMethods = state.paymentMethods;

    if (!paymentMethods.isFetching) {
      dispatch(fetchPaymentMethodsRequest());
      getPaymentMethods()
        .then((fetchedPaymentMethods) => {
          dispatch(fetchPaymentMethodsSuccess(fetchedPaymentMethods));
        })
        .catch((error) => {
          dispatch(setError(error));
        });
    }
  };
export const addPaymentMethod = (
  method: PaymentMethod,
): AddPaymentMethodAction => ({
  type: 'ADD_PAYMENT_METHOD',
  method,
});
export const removePaymentMethod = (
  methodId: string,
): RemovePaymentMethodAction => ({
  type: 'REMOVE_PAYMENT_METHOD',
  methodId,
});
